import { createContext, useContext } from 'react';
import type { Location } from 'react-router';

import type { UserDataModel } from './auth.model';
interface AuthContextType {
  user: UserDataModel | null;
  signin: (location: Location, callback: VoidFunction) => void;
  signout: () => void;
}

export const AuthContext = createContext<AuthContextType>({
  user: null,
  signin: () => ({}),
  signout: () => ({})
});
export const useAuth = () => useContext(AuthContext);
